import { render, staticRenderFns } from "./SystemsMessageInfo.vue?vue&type=template&id=297e7f8e&"
import script from "./SystemsMessageInfo.vue?vue&type=script&lang=js&"
export * from "./SystemsMessageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports